/**
 * Convert a diplsay value into a property
 * 
 * @param {string} property Convert the given text into a known property
 */
export function convertProperty(property) {
    //["Running", "Non-Running", "Require Forklift"]
    var value;
    switch (property) {
        case "Sedan/Hatchback":
            value = "SEDAN";
            break;
        case "Bakkie":
            value = "BAKKIE";
            break;
        case "SUV":
            value = "SUV";
            break;
        case "Minivan":
            value = "MINIVAN";
            break;
        case "Exotic / Other":
            value = "SPECIAL";
            break;
        case "I am covered":
            value = "OWN_INSURANCE";
            break;
        case "Own risk (no cover)":
            value = "NO_INSURANCE";
            break;
        case "Running":
            value = "RUNNING";
            break;
        case "Non-Running":
            value = "NON_RUNNING";
            break;
        case "Require Forklift":
            value = "REQUIRE_FORKLIFT";
            break;
        default:
            value = "";
    }
    return value;
}